const cardItems = [
  {
    title: '《星际迷航：新纪元》',
    desc: '年度科幻巨制，讲述人类探索未知星域的壮阔旅程，视觉效果震撼。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20space%20adventure%20cinematic%20scene%20with%20starship%20and%20distant%20galaxy%2C%20warm%20golden%20nebulae%20lighting%2C%20dramatic%20sci-fi%20atmosphere%2C%20film%20production%20quality%2C%20dark%20space%20background&width=600&height=400&seq=mahua-card-01&orientation=landscape',
    meta: '科幻 / 2026',
    rating: '8.6',
    tag: '新片',
  },
  {
    title: '《深夜食堂》第七季',
    desc: '温暖治愈的美食故事继续上演，每集一个小故事，抚慰都市人的心灵。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20style%20kitchen%20at%20night%20with%20soft%20amber%20lighting%2C%20steaming%20food%20on%20counter%2C%20intimate%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background%20with%20warm%20glow&width=600&height=400&seq=mahua-card-02&orientation=landscape',
    meta: '剧情 / 2026',
    rating: '9.1',
    tag: '热播',
  },
  {
    title: '《逆光飞翔》',
    desc: '青春励志题材，讲述年轻舞者追逐梦想的故事，感人至深催人泪下。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dance%20performance%20on%20stage%20with%20dramatic%20golden%20backlighting%2C%20warm%20cinematic%20tones%2C%20graceful%20movement%20captured%2C%20inspiring%20atmosphere%2C%20dark%20background%20with%20spotlight%2C%20artistic%20composition&width=600&height=400&seq=mahua-card-03&orientation=landscape',
    meta: '剧情 / 2026',
    rating: '8.3',
    tag: '推荐',
  },
  {
    title: '《密室逃脱》第五季',
    desc: '高智商推理真人秀，全新赛制升级，明星嘉宾脑力全开挑战极限。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20escape%20room%20set%20design%20with%20dramatic%20warm%20lighting%2C%20intricate%20puzzle%20room%20details%2C%20suspenseful%20cinematic%20atmosphere%2C%20amber%20and%20golden%20tones%2C%20dark%20corners&width=600&height=400&seq=mahua-card-04&orientation=landscape',
    meta: '综艺 / 2026',
    rating: '8.9',
    tag: '热门',
  },
  {
    title: '《江南烟雨》',
    desc: '民国背景的年代大剧，细腻描绘乱世中的爱恨情仇与家族兴衰。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20period%20drama%20scene%20with%20rainy%20ancient%20town%2C%20soft%20warm%20lantern%20lighting%2C%20nostalgic%20atmosphere%2C%20traditional%20architecture%2C%20cinematic%20composition%2C%20dark%20moody%20sky&width=600&height=400&seq=mahua-card-05&orientation=landscape',
    meta: '年代剧 / 2026',
    rating: '8.7',
    tag: '热播',
  },
  {
    title: '《动物星球》纪录片特辑',
    desc: 'BBC级别自然纪录片，呈现地球上最震撼的野生动物奇观与生态故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20wildlife%20documentary%20scene%20in%20golden%20savanna%20sunset%2C%20majestic%20animals%20in%20natural%20habitat%2C%20warm%20amber%20lighting%2C%20cinematic%20nature%20photography%2C%20dark%20silhouette%20background&width=600&height=400&seq=mahua-card-06&orientation=landscape',
    meta: '纪录片 / 2025',
    rating: '9.4',
    tag: '高分',
  },
  {
    title: '《笑傲江湖》经典修复版',
    desc: '武侠经典4K修复重映，江湖不再远，侠义永流传。重温金庸笔下的快意恩仇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20martial%20arts%20film%20scene%20with%20misty%20mountains%2C%20warm%20golden%20sunset%20lighting%2C%20elegant%20swordsman%20silhouette%2C%20cinematic%20wuxia%20atmosphere%2C%20dark%20mountain%20background&width=600&height=400&seq=mahua-card-07&orientation=landscape',
    meta: '武侠 / 经典',
    rating: '9.2',
    tag: '经典',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热播精选
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心甄选当季最值得看的优质影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/9]' : 'aspect-[3/2]'}`}>
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded text-[11px] font-medium text-background-50 bg-accent-500">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded text-[11px] font-semibold text-background-50 bg-primary-500/90">
                  {item.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                  {item.desc}
                </p>
                <span className="text-[11px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                  {item.meta}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}